import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataMinimumEver } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function MinimumEver(props: IElementDataMinimumEver) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { elementType = '', minValue = '', minReachedOn = '', isReportMetric, settings } = props;
    const fieldKey: ElementMetadataFieldName = 'minimum_ever';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (
        !fieldMetadataDisplay ||
        (!['metric', 'multi-metric chart'].includes(elementType) && !isReportMetric) ||
        !minValue
    )
        return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t(`element_data_label.${fieldKey}`)}</ElementDataRowLabel>
            <ElementDataRowValue>
                <Box component={'span'} sx={{ fontWeight: 600 }}>
                    {minValue}
                </Box>
                {minReachedOn && <> {minReachedOn}</>}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
